import * as types from './action-types';

const FamilySearchState = (index) => ({
  possibleRoots: [],
  token: null,
});

export function familySearchReducer(state = FamilySearchState(), {payload, type}) {
  switch (type) {
    case types.SET_FAMILY_SEARCH_TOKEN:
      return Object.assign({}, state, {
        token: payload,
      });

    case types.SET_POSSIBLE_ROOTS:
      return Object.assign({}, state, {
        possibleRoots: payload,
      });
    
    default: 
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/core/family-search/reducer.js